import { useEffect, useRef, useState } from "react";

export default function TextTruncate({ text, className = '', resizedCount = null, tooltip = null, showTooltip = true, alwaysShowTooltip = false, ...rest }) {
  const containerRef = useRef(null);
  const textRef = useRef(null);
  const [isOverflow, setIsOverflow] = useState(false);

  const checkOverflow = () => {
    if (containerRef.current && textRef.current) {
      const containerWidth = containerRef.current.offsetWidth;
      const textWidth = textRef.current.offsetWidth;
      setIsOverflow(textWidth > containerWidth);
    }
  };

  useEffect(() => {
    checkOverflow();
  }, [text, resizedCount]);

  return <div ref={containerRef} className={`text-truncate ${className}`} data-tooltip-id={(showTooltip && isOverflow) || alwaysShowTooltip ? `text-overflow-tooltip` : null} data-tooltip-content={tooltip !== null ? tooltip : text} {...rest}>
    <span ref={textRef}>{text}</span>
  </div>;
};
